<template>
  <ul class="p-5 space-y-5">
    <li v-for="item in data" :key="item.id" class="flex items-center group">
      <div
        v-if="item.id === 'whatsnew' && newNews"
        class="w-2 h-2 mr-3 bg-highlight rounded-full"
      />
      <lm-icon
        class="text-gray-500 group-hover:text-highlight"
        :class="{'text-highlight': $route.name === item.id}"
        :icon="item.icon"
        size="18"
      />
      <span
        class="ml-2 font-mono text-s text-gray-700 cursor-pointer group-hover:text-highlight"
        :class="{'text-highlight': $route.name === item.id}"
        @click="itemSelected(item.id)"
        >{{ item.label }}</span
      >
    </li>
  </ul>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
import auth from '@/lib/auth'
import {Modal} from '@/lib/definitions'
import {mapGetters} from 'vuex'
const ids = {
  HOME: 'home',
  PROFILE: 'profile',
  TUTORIALS: 'tutorials',
  WHATSNEW: 'whatsnew',
  HELP: 'help',
  LOGOUT: 'logout'
}
export default {
  name: 'NavList',
  components: {LmIcon},
  data() {
    return {
      data: [
        {
          id: ids.HOME,
          label: 'Home',
          icon: 'cottage'
        },
        {
          id: ids.PROFILE,
          label: 'Account Settings',
          icon: 'settings'
        },
        {
          id: ids.TUTORIALS,
          label: 'Tutorials',
          icon: 'school'
        },
        {
          id: ids.WHATSNEW,
          label: "What's New",
          icon: 'newReleases'
        },
        {
          id: ids.HELP,
          label: 'Help and Feedback',
          icon: 'contactSupport'
        },
        {
          id: ids.LOGOUT,
          label: 'Log Out',
          icon: 'logout'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['newNews'])
  },
  methods: {
    itemSelected(id) {
      if (this.$route.name === id) return
      switch (id) {
        case ids.HOME:
        case ids.PROFILE:
        case ids.TUTORIALS:
          this.navigateTo(id)
          break
        case ids.WHATSNEW:
          this.openModal(Modal.WHATS_NEW)
          break
        case ids.HELP:
          this.openModal(Modal.FEEDBACK)
          break
        case ids.LOGOUT:
          auth.logout()
          break
      }
    },
    navigateTo(route) {
      this.$router.push({name: route})
      this.$emit('select')
    },
    openModal(type) {
      this.$router.pushQuery({modal: type})
    }
  }
}
</script>
